import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import AppLayout from "../layouts/AppLayout.jsx";
import useChangeLanguage from "../../logic/useChangeLanguage.js";

const ContentAnnonces = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [annonces, setAnnonces] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("onpr_language") || "fr";
  });

  const { _t, getArticleTitle, getArticleBody } = useChangeLanguage();

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.annonces,
    isLoading: state.apiData?.loading?.annonces,
  }));

  useEffect(() => {
    getAnnonces();
  }, []);

  useEffect(() => {
    if (data?.data) {
      setAnnonces(data.data);
    }
  }, [data]);

  const getAnnonces = (page = 1) => {
    dispatch(
      fetchApiData({
        url: `annonces?page=${page}`,
        itemKey: "annonces",
      })
    );
    setCurrentPage(page);
  };

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem("onpr_language", lang);
  };

  const handleAnnonceClick = (annonce) => {
    history.push(`/annonce/${annonce.id}`);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const getExcerpt = (annonce) => {
    // const body = currentLang === 'fr' ? annonce.body : annonce.body_en;
    const text = stripHtml(getArticleBody(annonce));
    return text.length > 200 ? text.substring(0, 200) + "..." : text;
  };

  if (isLoading) {
    return (
      <div className="annonce-list-container">
        <h2 className="section-title">Annonces ONPR</h2>
        <div className="text-center py-5">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "3rem", color: "#00a652" }}
          ></i>
          <p>Chargement des annonces...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="annonce-list-container">
      <div className="annonce-header">
        <h2 className="section-title">Annonces ONPR</h2>
      </div>

      {annonces.length === 0 ? (
        <div className="no-data-placeholder">
          <i
            className="pi pi-inbox"
            style={{ fontSize: "4rem", color: "#ccc" }}
          ></i>
          <p>Aucune annonce disponible</p>
        </div>
      ) : (
        <>
          <div className="annonce-grid">
            {annonces.map((annonce) => (
              <div
                key={annonce.id}
                className="annonce-card"
                onClick={() => handleAnnonceClick(annonce)}
              >
                <div className="annonce-icon">
                  <i className="pi pi-megaphone"></i>
                </div>
                <div className="annonce-content">
                  <h3 className="annonce-title">{getArticleTitle(annonce)}</h3>
                  <p className="annonce-excerpt">{getExcerpt(annonce)}</p>
                  <span className="annonce-date">
                    <i className="pi pi-calendar"></i>{" "}
                    {new Date(annonce.created_at).toLocaleDateString("fr-FR")}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {data?.last_page > 1 && (
            <div className="pagination">
              <button
                onClick={() => getAnnonces(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                <i className="pi pi-angle-left"></i> Précédent
              </button>
              <span className="pagination-info">
                Page {currentPage} sur {data.last_page}
              </span>
              <button
                onClick={() => getAnnonces(currentPage + 1)}
                disabled={currentPage === data.last_page}
                className="pagination-btn"
              >
                Suivant <i className="pi pi-angle-right"></i>
              </button>
            </div>
          )}
        </>
      )}

      <style jsx>{`
        .annonce-list-container {
          max-width: 1200px;
          margin: 30px auto;
          padding: 0 20px;
        }
        .annonce-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 20px;
        }
        .section-title {
          color: #00a652;
          font-size: 1.8rem;
          margin: 0;
          padding-bottom: 15px;
          border-bottom: 4px solid #d32f2f;
          position: relative;
        }
        .section-title::before {
          content: "";
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100px;
          height: 4px;
          background: #00a652;
        }
        .annonce-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 25px;
        }
        .annonce-card {
          background: white;
          border-radius: 12px;
          padding: 25px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          transition: all 0.3s;
          border-left: 5px solid #00a652;
          cursor: pointer;
          display: flex;
          gap: 20px;
        }
        .annonce-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
          border-left-color: #d32f2f;
        }
        .annonce-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #00a652 0%, #2d8659 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .annonce-icon i {
          font-size: 1.8rem;
          color: white;
        }
        .annonce-content {
          flex: 1;
        }
        .annonce-title {
          color: #00a652;
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 1.4;
        }
        .annonce-excerpt {
          color: #666;
          font-size: 0.95rem;
          line-height: 1.6;
          margin-bottom: 12px;
        }
        .annonce-date {
          color: #d32f2f;
          font-size: 0.85rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 5px;
        }
        .no-data-placeholder {
          text-align: center;
          padding: 60px 20px;
        }
        .no-data-placeholder p {
          color: #999;
          font-size: 1.1rem;
          margin-top: 15px;
        }
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-top: 30px;
          padding: 20px;
        }
        .pagination-btn {
          background: #00a652;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s;
          font-weight: 600;
        }
        .pagination-btn:hover:not(:disabled) {
          background: #d32f2f;
          transform: translateY(-2px);
        }
        .pagination-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
          opacity: 0.6;
        }
        .pagination-info {
          color: #00a652;
          font-weight: 600;
        }
        @media (max-width: 768px) {
          .annonce-grid {
            grid-template-columns: 1fr;
          }
          .annonce-header {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </div>
  );
};

const AnnonceList = () => {
  return (
    <AppLayout>
      <ContentAnnonces />
    </AppLayout>
  );
};

export default AnnonceList;
